import diamondBaseUrl from "../assets/phaser-hq/diamond-base.png";
import diamondUpgradedUrl from "../assets/phaser-hq/diamond-upgraded.png";
import homeBackgroundUrl from "../assets/phaser-hq/home-background.png";
import crystalOrbHdUrl from "../assets/phaser-astrolabe-hd/crystal-orb-runtime.webp";
import innerRingHdUrl from "../assets/phaser-astrolabe-hd/inner-ring-runtime.webp";
import outerRingHdUrl from "../assets/phaser-astrolabe-hd/outer-ring-slim-runtime.webp";
import workshopInteriorUrl from "../assets/phaser-facet-quarter/workshop-interior.webp";
import energyCapacityUrl from "../assets/phaser-facet-quarter/energy-capacity-v2.webp";
import energyRecoveryUrl from "../assets/phaser-facet-quarter/energy-recovery-v2.webp";
import energySigilUrl from "../assets/phaser-facet-quarter/energy-sigil-v2.webp";
import contourMachineUrl from "../assets/phaser-facet-quarter/contour-machine.webp";
import trophyHallInteriorUrl from "../assets/phaser-trophy-hall/trophy-hall-interior.webp";
import sealOfDayUrl from "../assets/phaser-trophy-hall/seal-of-day.webp";
import trialPrecisionUrl from "../assets/phaser-trophy-hall/trial-precision.webp";
import trialPassiveUrl from "../assets/phaser-trophy-hall/trial-passive.webp";
import achievementLivingFacetUrl from "../assets/phaser-trophy-hall/achievement-living-facet.webp";
import achievementMasterRhythmUrl from "../assets/phaser-trophy-hall/achievement-master-rhythm.webp";
import achievementLightArchitectUrl from "../assets/phaser-trophy-hall/achievement-light-architect.webp";
import achievementMakersCircleUrl from "../assets/phaser-trophy-hall/achievement-makers-circle.webp";
import achievementPerfectFacetUrl from "../assets/phaser-trophy-hall/achievement-perfect-facet.webp";
import achievementCrystalReserveUrl from "../assets/phaser-trophy-hall/achievement-crystal-reserve.webp";
import achievementSilentCurrentUrl from "../assets/phaser-trophy-hall/achievement-silent-current.webp";
import achievementArenaGuardianUrl from "../assets/phaser-trophy-hall/achievement-arena-guardian.webp";
import achievementSeasonOneParticipantUrl from "../assets/phaser-trophy-hall/achievement-season-one-participant.webp";
import achievementStreakSevenUrl from "../assets/phaser-trophy-hall/achievement-streak-seven.webp";
import achievementStreakFifteenUrl from "../assets/phaser-trophy-hall/achievement-streak-fifteen.webp";
import achievementStreakThirtyUrl from "../assets/phaser-trophy-hall/achievement-streak-thirty.webp";
import achievementChainConquerorUrl from "../assets/phaser-trophy-hall/achievement-chain-conqueror.webp";
import achievementBranchMasterUrl from "../assets/phaser-trophy-hall/achievement-branch-master.webp";
import achievementWorkshopSovereignUrl from "../assets/phaser-trophy-hall/achievement-workshop-sovereign.webp";
import achievementPvpFirstWinUrl from "../assets/phaser-trophy-hall/achievement-pvp-first-win.webp";
import achievementPvpTenWinsUrl from "../assets/phaser-trophy-hall/achievement-pvp-ten-wins.webp";
import achievementArenaTenMatchesUrl from "../assets/phaser-trophy-hall/achievement-arena-ten-matches.webp";
import achievementArenaFiftyMatchesUrl from "../assets/phaser-trophy-hall/achievement-arena-fifty-matches.webp";
import achievementActiveFriendOneUrl from "../assets/phaser-trophy-hall/achievement-active-friend-one.webp";
import achievementActiveFriendThreeUrl from "../assets/phaser-trophy-hall/achievement-active-friend-three.webp";
import achievementActiveFriendTenUrl from "../assets/phaser-trophy-hall/achievement-active-friend-ten.webp";
import achievementTopTenPercentUrl from "../assets/phaser-trophy-hall/achievement-top-ten-percent.webp";
import achievementTopHundredUrl from "../assets/phaser-trophy-hall/achievement-top-hundred.webp";
import achievementTopTenUrl from "../assets/phaser-trophy-hall/achievement-top-ten.webp";
import achievementSeasonChampionUrl from "../assets/phaser-trophy-hall/achievement-season-champion.webp";
import seasonCrownUrl from "../assets/phaser-trophy-hall/season-crown.webp";
import makersClubSanctuaryUrl from "../assets/phaser-masters-club/makers-club-sanctuary.webp";
import covenantBeaconUrl from "../assets/phaser-masters-club/covenant-beacon.webp";
import nearCircleSignetUrl from "../assets/phaser-masters-club/near-circle-signet.webp";
import farCircleSignetUrl from "../assets/phaser-masters-club/far-circle-signet.webp";
import invitationKeyUrl from "../assets/phaser-masters-club/invitation-key.webp";
import memberMedallionUrl from "../assets/phaser-masters-club/member-medallion.webp";
import arenaGoalkeeperReadyUrl from "../assets/phaser-arena/goalkeeper-ready.webp";
import arenaGoalkeeperDiveUrl from "../assets/phaser-arena/goalkeeper-dive.webp";
import arenaStrikerKickUrl from "../assets/phaser-arena/striker-kick.webp";
import arenaBallUrl from "../assets/phaser-arena/arena-ball.webp";
import arenaGoalNetV4Url from "../assets/phaser-arena/arena-goal-net-v4.webp";
import arenaGoalkeeperBackReadyV4Url from "../assets/phaser-arena/goalkeeper-back-ready-v4.webp";
import arenaGoalkeeperBackBlockCentreV4Url from "../assets/phaser-arena/goalkeeper-back-block-centre-v4.webp";
import facetKeeperArenaV6Url from "../assets/phaser-onboarding-v6/keeper-arena.png";
import facetKeeperClubReturnV6Url from "../assets/phaser-onboarding-v6/keeper-club-return.png";
import facetKeeperClubV6Url from "../assets/phaser-onboarding-v6/keeper-club.png";
import facetKeeperCompleteV6Url from "../assets/phaser-onboarding-v6/keeper-complete.png";
import facetKeeperMapV6Url from "../assets/phaser-onboarding-v6/keeper-map.png";
import facetKeeperPassiveV6Url from "../assets/phaser-onboarding-v6/keeper-passive.png";
import facetKeeperSeasonReturnV6Url from "../assets/phaser-onboarding-v6/keeper-season-return.png";
import facetKeeperSeasonV6Url from "../assets/phaser-onboarding-v6/keeper-season.png";
import facetKeeperTapV6Url from "../assets/phaser-onboarding-v6/keeper-tap.png";
import facetKeeperTrophyV6Url from "../assets/phaser-onboarding-v6/keeper-trophy.png";
import facetKeeperUpgradeV6Url from "../assets/phaser-onboarding-v6/keeper-upgrade.png";
import facetKeeperWelcomeV6Url from "../assets/phaser-onboarding-v6/keeper-welcome.png";
import facetKeeperWorkshopV6Url from "../assets/phaser-onboarding-v6/keeper-workshop.png";
import premiumShopBackgroundUrl from "../assets/phaser-premium-liveops/premium-shop-vault.png";
import premiumOfflineReserveUrl from "../assets/phaser-premium-liveops/offline-reserve.png";
import premiumPassiveBoosterUrl from "../assets/phaser-premium-liveops/passive-booster.png";
import premiumAuroraSkinUrl from "../assets/phaser-premium-liveops/aurora-skin.png";
import premiumBlackDiamondSkinV2Url from "../assets/phaser-premium-liveops/black-diamond-skin-v2.png";
import premiumSolarHeartSkinUrl from "../assets/phaser-premium-liveops/solar-heart-skin.png";
import premiumEmeraldAbyssSkinUrl from "../assets/phaser-premium-liveops/emerald-abyss-skin.png";
import premiumSeasonSignetUrl from "../assets/phaser-premium-liveops/season-signet.png";
import seasonZeroParticipantSignetUrl from "../assets/phaser-premium-liveops/season-zero-participant.png";
import arenaSharedPitchV16Url from "../assets/phaser-arena-hd/shared-pitch-v16.png";
import arenaGoalkeeperCentreSaveV14Url from "../assets/phaser-arena-hd/goalkeeper-centre-save-v14.png";
import arenaOpponentStrikerWindupV9Url from "../assets/phaser-arena-hd/opponent-striker-windup-v9.png";
import arenaOpponentStrikerContactV9Url from "../assets/phaser-arena-hd/opponent-striker-contact-v9.png";
import arenaGoalkeeperBackDiveLeftV7Url from "../assets/phaser-arena-hd/goalkeeper-back-dive-left-v7.png";
import arenaGoalkeeperBackDiveRightV7Url from "../assets/phaser-arena-hd/goalkeeper-back-dive-right-v7.png";

export const FACET_QUARTER_ART = {
  styleId: "style-8001fb7abc",
  homeBackground: {
    key: "facet-quarter-home-background",
    url: homeBackgroundUrl,
    width: 1138,
    height: 2528,
  },
  diamond: {
    base: {
      key: "facet-quarter-diamond-base",
      url: diamondBaseUrl,
      width: 1640,
      height: 1440,
    },
    upgraded: {
      key: "facet-quarter-diamond-upgraded",
      url: diamondUpgradedUrl,
      width: 1754,
      height: 1514,
    },
  },
} as const;

export const OFFLINE_REWARD_ART = {
  styleId: "style-a114b8e4a2",
  background: {
    key: "offline-reward-workshop-background",
    url: workshopInteriorUrl,
    width: 1138,
    height: 2528,
  },
  astrolabe: {
    core: {
      key: "offline-reward-pure-crystal-orb-hd",
      url: crystalOrbHdUrl,
      width: 768,
      height: 768,
    },
    outerRing: {
      key: "offline-reward-slim-outer-ring-hd",
      url: outerRingHdUrl,
      width: 768,
      height: 766,
    },
    innerRing: {
      key: "offline-reward-orthographic-inner-ring-hd",
      url: innerRingHdUrl,
      width: 755,
      height: 768,
    },
  },
} as const;

export const WORKSHOP_ENERGY_ART = {
  styleId: "style-a114b8e4a2",
  capacity: {
    key: "workshop-energy-capacity-v2",
    url: energyCapacityUrl,
    width: 656,
    height: 1000,
  },
  recovery: {
    key: "workshop-energy-recovery-v2",
    url: energyRecoveryUrl,
    width: 836,
    height: 1014,
  },
  sigil: {
    key: "workshop-energy-sigil-v2",
    url: energySigilUrl,
    width: 326,
    height: 486,
  },
} as const;

export const TROPHY_HALL_ART = {
  styleId: "style-a114b8e4a2",
  background: {
    key: "trophy-hall-interior",
    url: trophyHallInteriorUrl,
    width: 720,
    height: 1599,
  },
  dailySeal: {
    key: "trophy-hall-seal-of-day",
    url: sealOfDayUrl,
    width: 544,
    height: 640,
  },
  trials: {
    precision: {
      key: "trophy-hall-trial-precision",
      url: trialPrecisionUrl,
      width: 372,
      height: 384,
    },
    upgrade: {
      key: "trophy-hall-trial-upgrade",
      url: contourMachineUrl,
      width: 914,
      height: 1057,
    },
    passive: {
      key: "trophy-hall-trial-passive",
      url: trialPassiveUrl,
      width: 279,
      height: 384,
    },
  },
  achievements: {
    "first-spark": {
      key: "trophy-hall-achievement-first-spark",
      url: energySigilUrl,
      width: 326,
      height: 486,
    },
    "living-facet": {
      key: "trophy-hall-achievement-living-facet",
      url: achievementLivingFacetUrl,
      width: 342,
      height: 505,
    },
    "master-rhythm": {
      key: "trophy-hall-achievement-master-rhythm",
      url: achievementMasterRhythmUrl,
      width: 512,
      height: 452,
    },
    "light-architect": {
      key: "trophy-hall-achievement-light-architect",
      url: achievementLightArchitectUrl,
      width: 478,
      height: 512,
    },
    "makers-circle": {
      key: "trophy-hall-achievement-makers-circle",
      url: achievementMakersCircleUrl,
      width: 508,
      height: 512,
    },
    "perfect-facet": {
      key: "trophy-hall-achievement-perfect-facet",
      url: achievementPerfectFacetUrl,
      width: 502,
      height: 512,
    },
    "crystal-reserve": {
      key: "trophy-hall-achievement-crystal-reserve",
      url: achievementCrystalReserveUrl,
      width: 361,
      height: 512,
    },
    "silent-current": {
      key: "trophy-hall-achievement-silent-current",
      url: achievementSilentCurrentUrl,
      width: 378,
      height: 512,
    },
    "arena-guardian": {
      key: "trophy-hall-achievement-arena-guardian",
      url: achievementArenaGuardianUrl,
      width: 381,
      height: 512,
    },
    "season-one-participant": {
      key: "trophy-hall-achievement-season-one-participant",
      url: achievementSeasonOneParticipantUrl,
      width: 266,
      height: 512,
    },
    "season-two-participant": { key: "trophy-hall-achievement-season-two-participant", url: achievementSeasonOneParticipantUrl, width: 266, height: 512 },
    "streak-seven": {
      key: "trophy-hall-achievement-streak-seven",
      url: achievementStreakSevenUrl,
      width: 426,
      height: 512,
    },
    "streak-fifteen": {
      key: "trophy-hall-achievement-streak-fifteen",
      url: achievementStreakFifteenUrl,
      width: 399,
      height: 512,
    },
    "streak-thirty": {
      key: "trophy-hall-achievement-streak-thirty",
      url: achievementStreakThirtyUrl,
      width: 301,
      height: 512,
    },
    "chain-conqueror": {
      key: "trophy-hall-achievement-chain-conqueror",
      url: achievementChainConquerorUrl,
      width: 463,
      height: 512,
    },
    "branch-master": {
      key: "trophy-hall-achievement-branch-master",
      url: achievementBranchMasterUrl,
      width: 410,
      height: 512,
    },
    "workshop-sovereign": {
      key: "trophy-hall-achievement-workshop-sovereign",
      url: achievementWorkshopSovereignUrl,
      width: 393,
      height: 512,
    },
    "pvp-first-win": {
      key: "trophy-hall-achievement-pvp-first-win",
      url: achievementPvpFirstWinUrl,
      width: 407,
      height: 512,
    },
    "pvp-ten-wins": {
      key: "trophy-hall-achievement-pvp-ten-wins",
      url: achievementPvpTenWinsUrl,
      width: 407,
      height: 512,
    },
    "arena-ten-matches": {
      key: "trophy-hall-achievement-arena-ten-matches",
      url: achievementArenaTenMatchesUrl,
      width: 359,
      height: 512,
    },
    "arena-fifty-matches": {
      key: "trophy-hall-achievement-arena-fifty-matches",
      url: achievementArenaFiftyMatchesUrl,
      width: 386,
      height: 512,
    },
    "active-friend-one": {
      key: "trophy-hall-achievement-active-friend-one",
      url: achievementActiveFriendOneUrl,
      width: 399,
      height: 512,
    },
    "active-friend-three": {
      key: "trophy-hall-achievement-active-friend-three",
      url: achievementActiveFriendThreeUrl,
      width: 512,
      height: 416,
    },
    "active-friend-ten": {
      key: "trophy-hall-achievement-active-friend-ten",
      url: achievementActiveFriendTenUrl,
      width: 512,
      height: 392,
    },
    "top-ten-percent": {
      key: "trophy-hall-achievement-top-ten-percent",
      url: achievementTopTenPercentUrl,
      width: 417,
      height: 512,
    },
    "top-hundred": {
      key: "trophy-hall-achievement-top-hundred",
      url: achievementTopHundredUrl,
      width: 395,
      height: 512,
    },
    "top-ten": {
      key: "trophy-hall-achievement-top-ten",
      url: achievementTopTenUrl,
      width: 384,
      height: 512,
    },
    "season-champion": {
      key: "trophy-hall-achievement-season-champion",
      url: achievementSeasonChampionUrl,
      width: 425,
      height: 512,
    },
  },
  seasonCrown: {
    key: "trophy-hall-season-crown",
    url: seasonCrownUrl,
    width: 528,
    height: 640,
  },
} as const;

export const PREMIUM_SHOP_ART = {
  styleId: "style-a114b8e4a2",
  background: {
    key: "premium-shop-vault",
    url: premiumShopBackgroundUrl,
    width: 360,
    height: 800,
  },
  offlineReserve: {
    key: "premium-shop-offline-reserve",
    url: premiumOfflineReserveUrl,
    width: 146,
    height: 256,
  },
  passiveBooster: {
    key: "premium-shop-passive-booster",
    url: premiumPassiveBoosterUrl,
    width: 212,
    height: 256,
  },
  auroraSkin: {
    key: "premium-shop-aurora-skin",
    url: premiumAuroraSkinUrl,
    width: 256,
    height: 217,
  },
  skins: {
    "skin-aurora-prism": {
      key: "premium-shop-aurora-skin",
      url: premiumAuroraSkinUrl,
      width: 256,
      height: 217,
    },
    "skin-black-diamond": {
      key: "premium-shop-black-diamond-skin",
      url: premiumBlackDiamondSkinV2Url,
      width: 1232,
      height: 1750,
    },
    "skin-solar-heart": {
      key: "premium-shop-solar-heart-skin",
      url: premiumSolarHeartSkinUrl,
      width: 1608,
      height: 1528,
    },
    "skin-emerald-abyss": {
      key: "premium-shop-emerald-abyss-skin",
      url: premiumEmeraldAbyssSkinUrl,
      width: 1468,
      height: 1110,
    },
  },
  seasonSignet: {
    key: "premium-shop-season-signet",
    url: premiumSeasonSignetUrl,
    width: 256,
    height: 255,
  },
  seasonZeroParticipant: {
    key: "season-zero-participant-signet",
    url: seasonZeroParticipantSignetUrl,
    width: 735,
    height: 742,
  },
} as const;

export const MAKERS_CLUB_ART = {
  styleId: "style-a114b8e4a2",
  background: {
    key: "makers-club-sanctuary",
    url: makersClubSanctuaryUrl,
    width: 720,
    height: 1599,
  },
  beacon: {
    key: "makers-club-covenant-beacon",
    url: covenantBeaconUrl,
    width: 640,
    height: 520,
  },
  nearSignet: {
    key: "makers-club-near-circle-signet",
    url: nearCircleSignetUrl,
    width: 256,
    height: 368,
  },
  farSignet: {
    key: "makers-club-far-circle-signet",
    url: farCircleSignetUrl,
    width: 320,
    height: 239,
  },
  invitationKey: {
    key: "makers-club-invitation-key",
    url: invitationKeyUrl,
    width: 224,
    height: 347,
  },
  memberMedallion: {
    key: "makers-club-member-medallion",
    url: memberMedallionUrl,
    width: 192,
    height: 275,
  },
} as const;

export const ARENA_ART = {
  styleId: "style-a114b8e4a2",
  background: {
    key: "facet-quarter-arena-shared-pitch-v16",
    url: arenaSharedPitchV16Url,
    width: 720,
    height: 1600,
  },
  defenseBackground: {
    key: "facet-quarter-arena-shared-pitch-v16",
    url: arenaSharedPitchV16Url,
    width: 720,
    height: 1600,
  },
  goalNet: {
    key: "facet-quarter-arena-goal-net-v4",
    url: arenaGoalNetV4Url,
    width: 1024,
    height: 541,
  },
  goalkeeperReady: {
    key: "facet-quarter-arena-goalkeeper-ready-v2",
    url: arenaGoalkeeperReadyUrl,
    width: 371,
    height: 720,
  },
  goalkeeperDive: {
    key: "facet-quarter-arena-goalkeeper-dive-v2",
    url: arenaGoalkeeperDiveUrl,
    width: 720,
    height: 476,
  },
  goalkeeperCentreSave: {
    key: "facet-quarter-arena-goalkeeper-centre-save-v14",
    url: arenaGoalkeeperCentreSaveV14Url,
    width: 141,
    height: 256,
  },
  strikerKick: {
    key: "facet-quarter-arena-striker-kick-v2",
    url: arenaStrikerKickUrl,
    width: 460,
    height: 624,
  },
  ball: {
    key: "facet-quarter-arena-ball-v2",
    url: arenaBallUrl,
    width: 252,
    height: 256,
  },
  opponentStrikerWindup: {
    key: "facet-quarter-arena-opponent-striker-windup-v9",
    url: arenaOpponentStrikerWindupV9Url,
    width: 117,
    height: 256,
  },
  opponentStrikerContact: {
    key: "facet-quarter-arena-opponent-striker-contact-v9",
    url: arenaOpponentStrikerContactV9Url,
    width: 161,
    height: 256,
  },
  defenseGoalkeeperReady: {
    key: "facet-quarter-arena-goalkeeper-back-ready-v4",
    url: arenaGoalkeeperBackReadyV4Url,
    width: 565,
    height: 768,
  },
  defenseGoalkeeperDiveLeft: {
    key: "facet-quarter-arena-goalkeeper-back-dive-left-v7",
    url: arenaGoalkeeperBackDiveLeftV7Url,
    width: 223,
    height: 256,
  },
  defenseGoalkeeperDiveRight: {
    key: "facet-quarter-arena-goalkeeper-back-dive-right-v7",
    url: arenaGoalkeeperBackDiveRightV7Url,
    width: 197,
    height: 256,
  },
  defenseGoalkeeperBlockCentre: {
    key: "facet-quarter-arena-goalkeeper-back-block-centre-v4",
    url: arenaGoalkeeperBackBlockCentreV4Url,
    width: 248,
    height: 768,
  },
} as const;

export const ONBOARDING_ART = {
  styleId: "style-a114b8e4a2",
  keeper: {
    welcome: {
      key: "facet-keeper-welcome-v6",
      url: facetKeeperWelcomeV6Url,
      width: 508,
      height: 940,
    },
    tap: {
      key: "facet-keeper-tap-v6",
      url: facetKeeperTapV6Url,
      width: 548,
      height: 932,
    },
    map: {
      key: "facet-keeper-map-v6",
      url: facetKeeperMapV6Url,
      width: 632,
      height: 922,
    },
    workshop: {
      key: "facet-keeper-workshop-v6",
      url: facetKeeperWorkshopV6Url,
      width: 544,
      height: 912,
    },
    upgrade: {
      key: "facet-keeper-upgrade-v6",
      url: facetKeeperUpgradeV6Url,
      width: 502,
      height: 938,
    },
    passive: {
      key: "facet-keeper-passive-v6",
      url: facetKeeperPassiveV6Url,
      width: 462,
      height: 1221,
    },
    trophy: {
      key: "facet-keeper-trophy-v6",
      url: facetKeeperTrophyV6Url,
      width: 592,
      height: 1244,
    },
    season: {
      key: "facet-keeper-season-v6",
      url: facetKeeperSeasonV6Url,
      width: 574,
      height: 1244,
    },
    seasonReturn: {
      key: "facet-keeper-season-return-v6",
      url: facetKeeperSeasonReturnV6Url,
      width: 454,
      height: 928,
    },
    club: {
      key: "facet-keeper-club-v6",
      url: facetKeeperClubV6Url,
      width: 468,
      height: 928,
    },
    clubReturn: {
      key: "facet-keeper-club-return-v6",
      url: facetKeeperClubReturnV6Url,
      width: 324,
      height: 918,
    },
    arena: {
      key: "facet-keeper-arena-v6",
      url: facetKeeperArenaV6Url,
      width: 454,
      height: 926,
    },
    complete: {
      key: "facet-keeper-complete-v6",
      url: facetKeeperCompleteV6Url,
      width: 508,
      height: 1265,
    },
  },
} as const;

export const ARENA_PRELOAD_ASSETS = [
  ARENA_ART.defenseBackground,
  ARENA_ART.goalNet,
  ARENA_ART.goalkeeperReady,
  ARENA_ART.goalkeeperDive,
  ARENA_ART.goalkeeperCentreSave,
  ARENA_ART.strikerKick,
  ARENA_ART.opponentStrikerWindup,
  ARENA_ART.opponentStrikerContact,
  ARENA_ART.defenseGoalkeeperReady,
  ARENA_ART.defenseGoalkeeperDiveLeft,
  ARENA_ART.defenseGoalkeeperDiveRight,
  ARENA_ART.defenseGoalkeeperBlockCentre,
  ARENA_ART.ball,
] as const;

export const ARENA_ASSET_COUNT = ARENA_PRELOAD_ASSETS.length;
